const present = (value) => value !== null && value !== undefined && String(value).trim() !== "";

export const buildClientInvoicingSalesOrderUrl = (instanceUniqueId, row = {}) => {
  const parentOrderId = row?.Order?.OrderId ?? row?.orderId;
  const salesOrderId = row?.salesOrderId;

  if (![instanceUniqueId, parentOrderId, salesOrderId].every(present)) return null;

  return `/instance/${encodeURIComponent(instanceUniqueId)}/sales/orders/${encodeURIComponent(parentOrderId)}/sales-order/${encodeURIComponent(salesOrderId)}`;
};
